import { create } from 'zustand';
import { useCustomRoleUpdateQueueStore } from './customRoleUpdateQueueStore';
import { useCredentialUpdateQueueStore } from './credentialUpdateQueueStore';

type CopilotSettingsRefreshStore = {
  pendingChatIds: Record<string, true>;
  markSettingsRefreshPending: (chatId: string) => void;
  consumeSettingsRefreshPending: (chatId: string) => boolean;
  markSettingsRefreshFromRoleCredentialQueues: () => void;
};

export const useCopilotSettingsRefreshStore =
  create<CopilotSettingsRefreshStore>((set, get) => ({
    pendingChatIds: {},

    markSettingsRefreshPending: (chatId) => {
      if (!chatId) {
        return;
      }
      set((state) => ({
        pendingChatIds: { ...state.pendingChatIds, [chatId]: true },
      }));
    },

    consumeSettingsRefreshPending: (chatId) => {
      const pending = get().pendingChatIds[chatId];
      if (!pending) {
        return false;
      }
      set((state) => {
        const nextPendingChatIds = { ...state.pendingChatIds };
        delete nextPendingChatIds[chatId];
        return { pendingChatIds: nextPendingChatIds };
      });
      return true;
    },

    markSettingsRefreshFromRoleCredentialQueues: () => {
      const roleChatId = useCustomRoleUpdateQueueStore.getState().sourceChatId;
      const credentialChatId =
        useCredentialUpdateQueueStore.getState().sourceChatId;
      const { markSettingsRefreshPending } = get();
      if (roleChatId) {
        markSettingsRefreshPending(roleChatId);
      }
      if (credentialChatId && credentialChatId !== roleChatId) {
        markSettingsRefreshPending(credentialChatId);
      }
    },
  }));
